import styles from '../../DealerLocator.module.scss';
import cx from 'classnames';

interface DealerLocatorSearchResultAddressProps {
  children: string;
  isStoreLocationMapViewUpdateFlag?: boolean;
}

export const DealerLocatorSearchResultAddress = ({
  children,
  isStoreLocationMapViewUpdateFlag = false
}: DealerLocatorSearchResultAddressProps) => (
  <p
    className={cx(
      styles['dealer-locator-text'],
      'cat-u-theme-typography-body my-0',
      {
        'cat-u-theme-typography-body-sm': isStoreLocationMapViewUpdateFlag,
        'cat-u-theme-typography-body': !isStoreLocationMapViewUpdateFlag
      }
    )}
  >
    {children}
  </p>
);
